export default String.raw`
{% include 'partials/common/date-format.html' -%}	

{% assign inquiryString = customer-profile.OfferQueryGET -%}
{% assign paginationPageNo = customer-profile.Inquiries.PageNo -%}

<div class="eshop__table-container products">
	<table data-template="partials/customer-profile/inquiries/inquiry-details.html">
		<colgroup>
			<col style="width:100px">
			<col style="width:150px">
		</colgroup>
		<thead>
			<tr>
				<th class="id">{{ translations.Number | Capitalize }}</th>
				<th>{{ translations.BuyDate }}</th>
				<th>{{ translations.Status }}</th>
			</tr>
		</thead>
		{% if customer-profile.Inquiries.TotalItems > 0 -%}
			{% for inquiry in customer-profile.Inquiries.List -%}
				<tbody>
					<tr tabindex="0" class="row can-hover load-deeper-lvl-js parent-container-reload-js open-order-details-js" data-id="{{ inquiry.Id }}" data-url="{{ page.Url }}?{{ inquiryString | H }}={{ inquiry.Id }}&deeper-lvl&tab=inquiry-details">
						<td class="id">{{ inquiry.Id }}</td>
						<td>{{ inquiry.Date | Date:dateFormat }}</td>
						<td>
							<div class="state {% if inquiry.Status == 0 -%} warning-container {% elseif inquiry.Status == 2 -%} success-container {% elseif inquiry.Status == 1 -%} info-container {% else -%} danger-container {% endif -%}">{{ inquiry.StatusText }}</div>
						</td>
					</tr>
				</tbody>
			{% endfor -%}
		{% endif -%}
	</table>
	{% if customer-profile.Inquiries.TotalItems > 0 -%}
		{% include 'partials/common/pagination.html' -%}
	{% else -%}
		<div class="no-data">{{ translations.NoInquiries }}</div>
	{% endif -%}
</div>
`